import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import "./index.scss"
import CustomTable from "../../../components/CustomTableGrid";
import Tooltip from "@material-ui/core/Tooltip";

import {
    users_get_rows_all, delete_user, create_user
} from "../../../store/actions/usersConfig";

import {
    Grid,
    DataTableSkeleton,
    ComposedModal,
    ModalHeader,
    ModalBody,
} from "carbon-components-react";

import moment from "moment";
import {TrashCan20} from "@carbon/icons-react";
import ModalDelete from "../../../components/ModalUser/delete";
import ModalCreate from "../../../components/ModalUser/create";
import {set_comment} from "../../../store/actions/rh";


const columns = [
    {
        name: 'user',
        title: 'Email',
        editable: false,

        order: 0,
        height: 38
    },
    {
        name: 'createdAt',
        title: 'Data de Criação',
        editable: false,
        comment: true,

        order: 1,
        height: 38
    },
    {
        name: 'delete_user',
        title: 'Deletar usuário',
        editable: false,
        comment: true,
        width: 200,
        order: 2,
        height: 38
    },

];


class Edit extends Component {

    state = {
        form: {
            modal_create: false,
            modal_erro_save: false,
            modal_delete: false,
            user: "",
            id: "",
        }
    };

    async componentDidMount() {
        try {
            await this.props.fetchData();
        } catch (e) {
            console.error(e);
        }
    }

    async saveRh(object) {
        await this.props.fetchSetData(object).then(data => {
            this.handleLoadingTabela();
        }).then(data => {
            this.setState({modal_save: true})
        }).catch(err => {
            return false;
        });
    }

    async saveDelete(user) {
        this.setState(prevState => ({
            form: {...prevState.form, modal_delete: false}
        }))
        await this.props.fetchDeleteUser({
            id: user.id,
            user: user.user,
        }).then(data => {
            this.handleLoadingTabela();
        }).then(data => {
            this.setState({modal_delete_save: true})
        }).catch(err => {
            return false;
        });
    }

    async saveCreate(user) {
        this.setState(prevState => ({
            form: {...prevState.form, modal_delete: false, modal_create: false}
        }))
        await this.props.fetchCreateUser({
            user: user.user,
        }).then(data => {
            this.handleLoadingTabela();
            this.setState({modal_save: true})
        }).catch(err => {
            this.setState({modal_erro_save: true})
        });
    }

    handleLoadingTabela = async (e) => {
        await this.props.fetchData().then(data => {
            return true;
        }).catch(err => {
            return false;
        })
    };

    onCloseModal = e => {
        this.setState(prevState => ({
            form: {...prevState.form, modal_delete: false, modal_create: false}
        }));
    };


    render() {

        let {data, isLoading,hasErrored_USER} = this.props;
        let createdAt = moment(new Date()).format(" DD MMM YY")
        const callApi = (unmutableRows, object) => this.saveRh(unmutableRows, object);
        const callCreate = () => {
            this.setState({
                form: {
                    id: "",
                    user: "",
                    modal_create: true
                },
            });
        };
        const callDelete = (id, user) => {
            this.setState({
                form: {
                    id: id,
                    user: user,
                    modal_delete: true
                },
            });
        };
        let rows =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                        parentId: null,
                        createdAt: execution.createdAt === undefined ? " - " : moment(execution.createdAt).format("DD/MM/yyyy"),
                        type: "row",
                        delete_user: <div>
                            <TrashCan20 size="small" style={{cursor: 'pointer', color: "#000"}}
                                        onClick={(e) => callDelete(execution._id, execution.user)}/>
                        </div>
                    };
                })
                : [];

        return (
            <Layout>
                <ModalDelete form={this.state.form}
                             onSubmitForm={(data) => this.saveDelete(data)}
                             onCloseModal={(data) => this.onCloseModal(data)}
                />
                <ModalCreate form={this.state.form}
                             onSubmitForm={(data) => this.saveCreate(data)}
                             onCloseModal={(data) => this.onCloseModal(data)}
                />
                <Grid class="painel" fullWidth>
                    <div className="container-fluid">
                        <div className="header-text header-text-report">
                            <h5>User ADMIN</h5>
                            <h3>Criação de usuários</h3>
                        </div>
                        <>
                            {isLoading ? (
                                <div style={{paddingTop: "30px", paddingRight: "20px", marginBottom: "50px"}}>
                                    <DataTableSkeleton/>
                                </div>
                            ) : (
                                <>
                                    {(this.state.modal_erro_save && hasErrored_USER) && (
                                        <ComposedModal size="xs" open preventCloseOnClickOutside
                                                       onClose={() => ( this.handleLoadingTabela())}>
                                            <ModalHeader title="OPS!"/>
                                            <ModalBody>
                                                Usuário já cadastrado.
                                            </ModalBody>
                                        </ComposedModal>
                                    )}
                                    {(this.state.modal_delete_save && !hasErrored_USER)&& (
                                        <ComposedModal size="xs" open preventCloseOnClickOutside
                                                       onClose={() => this.setState({modal_delete_save: false})}>
                                            <ModalHeader title="Status"/>
                                            <ModalBody>
                                                Usuário excluido com sucesso.
                                            </ModalBody>
                                        </ComposedModal>
                                    )}
                                    {(this.state.modal_save && !hasErrored_USER) && (
                                        <ComposedModal size="xs" open preventCloseOnClickOutside
                                                       onClose={() => this.setState({modal_save: false})}>
                                            <ModalHeader title="Status"/>
                                            <ModalBody>
                                                Salvo com sucesso!
                                            </ModalBody>
                                        </ComposedModal>
                                    )}

                                    <div style={{
                                        paddingTop: "30px",
                                        paddingRight: "20px",
                                        marginBottom: "50px"
                                    }}>
                                        <CustomTable headerInformation={{
                                            "title": rows.length + " usuários criados",
                                            "date": createdAt
                                        }}
                                                     unmutableRows={rows}
                                                     columns={columns}
                                                     rowsData={rows}
                                                     editable={false}
                                                     createUser={true}
                                                     refreshData={callApi}
                                                     callDelete={callDelete}
                                                     callCreate={callCreate}
                                                     undoData={this.handleLoadingTabela}
                                        />
                                    </div>
                                </>
                            )}
                        </>

                    </div>
                </Grid>
            </Layout>
        )
    }
}

const
    mapStateToProps = ({usersconfig}) => usersconfig;

const
    mapDispatchToProps = dispatch => ({
        fetchData: () => dispatch(users_get_rows_all()),
        fetchDeleteUser: (user) => dispatch(delete_user(user)),
        fetchCreateUser: (user) => dispatch(create_user(user)),
    });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Edit);
